import Vue from 'vue';
import Router from 'vue-router';
import * as Sentry from '@sentry/vue';

import HomePage from '../pages/Accueil';
import LoginPage from '../pages/Membres/ConnexionMembre';
import ActivitesPage from '../pages/Activites';
import CoursInitPage from '../pages/Cours/Cours_Initiation';
import CoursSpecialisesPage from '../pages/Cours/Cours_Specialises';
import CoursReserve from '@/pages/Cours/Cours_Reserve';
import AvicoursePage from '../pages/Avicourse/Avicourse';
import AvicourseSinglePage from '../pages/Avicourse/Avicourse_Historique';
import EcoloDefiPage from '../pages/EcoloDefi/EcoloDefi';
import EcoloDefiSinglePage from '../pages/EcoloDefi/EcoloDefi_Historique';
import Grand24Page from '../pages/Grand24h/Grand_24h';
import Grand24SinglePage from '../pages/Grand24h/Grand_24h_Historique';
import CommanditairesPage from '../pages/Commanditaires';
import DevenirMembrePage from '../pages/Membres/DevenirMembre';
import InscriptionPage from '../pages/Membres/Inscription';
import FaireDonPage from '../pages/FaireDon';
import BoutiquePage from '../pages/Magasin/Magasin';
import ProductPage from '../pages/Magasin/Magasin_Produit';
import CartPage from '../pages/Magasin/Panier';
import MembersPage from '../pages/SectionMembre';
import ResetPasswordPage from '../pages/Membres/ReinitialisationMotDePasse';
import ActivationMembreExistant from '@/pages/Membres/ActivationMembreExistant';

import ConferencePage from '../pages/Conferences';

import { store } from '../store/index';
import PageGeneriqueHtml from '@/pages/Base/PageGeneriqueHtml';

Vue.use(Router);

Sentry.init({
  Vue,
  dsn: 'https://f930e8d3367264834ac1d35471e3041b@o142359.ingest.us.sentry.io/4507692575031296',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.browserProfilingIntegration()
  ],
  // Performance Monitoring
  tracesSampleRate: 0.5, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  // Profiling
  profilesSampleRate: 1.0
});

export const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      name: 'HomePage',
      path: '/accueil',
      component: HomePage,
      meta: { title: 'Club des ornithologues de Québec (COQ)' }
    },
    {
      name: 'PresentationPage',
      path: '/presentation',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/presentation.html'
      },
      meta: { title: 'Présentation' }
    },
    {
      name: 'CaPage',
      path: '/conseil-administration',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/ca.html'
      },
      meta: { title: 'Le CA du COQ' }
    },
    {
      name: 'ResponsablesPage',
      path: '/responsables',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/responsables.html'
      },
      meta: { title: 'Responsables' }
    },
    {
      name: 'ActivitesPage',
      path: '/activites',
      component: ActivitesPage,
      meta: { title: 'Activités' }
    },
    {
      name: 'CoursInitPage',
      path: '/cours/initiation',
      component: CoursInitPage,
      meta: { title: "Cours d'initiation" }
    },
    {
      name: 'CoursSpecialisesPage',
      path: '/cours/specialises',
      component: CoursSpecialisesPage,
      meta: { title: 'Cours spécialisés' }
    },
    {
      name: 'CoursReservePage',
      path: '/cours/reserve',
      component: CoursReserve,
      meta: { title: 'Cours en réserve' }
    },
    {
      name: 'AvicoursePage',
      path: '/activites/avicourse',
      component: AvicoursePage,
      meta: { title: 'Avicourse' }
    },
    {
      name: 'AvicourseSinglePage',
      path: '/activites/avicourse/:year',
      component: AvicourseSinglePage,
      meta: { title: 'Avicourse' }
    },
    {
      name: 'EcoloDefiPage',
      path: '/activites/ecolodefi',
      component: EcoloDefiPage,
      meta: { title: 'Écolo-défi' }
    },
    {
      name: 'EcoloDefiSinglePage',
      path: '/activites/ecolodefi/photos/:year',
      component: EcoloDefiSinglePage,
      meta: { title: 'Écolo-défi' }
    },
    {
      name: 'Grand24Page',
      path: '/activites/grand24h',
      component: Grand24Page,
      meta: { title: 'Grand 24 heures' }
    },
    {
      name: 'Grand24SinglePage',
      path: '/activites/grand24h/compte-rendu/:year',
      component: Grand24SinglePage,
      meta: { title: 'Grand 24 heures' }
    },
    {
      name: 'Page60eme',
      path: '/archives/60eme',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/coq-60-ans.html'
      },
      meta: { title: '60ème du COQ' }
    },
    {
      name: 'RecensementNoelPage',
      path: '/recensement/noel',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/recensement-noel.html'
      },
      meta: { title: 'Recensement Noël' }
    },
    {
      name: 'RecensementQuebecPage',
      path: '/recensement/noel/quebec',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/recensement-quebec.html'
      },
      meta: { title: 'Recensement Québec' }
    },
    {
      name: 'RecensementStIgnacePage',
      path: '/recensement/noel/cap-st-ignace',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/recensement-cap-st-ignace.html'
      },
      meta: { title: 'Recensement St Ignace' }
    },
    {
      name: 'RecensementNeuvillePage',
      path: '/recensement/noel/neuville-tilly',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/recensement-neuville.html'
      },
      meta: { title: 'Recensement Neuville' }
    },
    {
      name: 'ObservationsOrniPage',
      path: '/observations-ornithologiques',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/observations-recentes.html'
      },
      meta: { title: 'Observations ornithologiques' }
    },
    {
      name: 'SoumissionObservationPage',
      path: '/soumission-observations',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/soumission-observations.html'
      },
      meta: { title: 'Soumettre vos observations' }
    },
    {
      name: 'ListesAnnoteesPage',
      path: '/listes-annotees',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/liste-annotees.html'
      },
      meta: { title: 'Listes annotées' }
    },
    {
      name: 'FaqPage',
      path: '/faq',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/faq.html'
      },
      meta: { title: 'Foire aux questions' }
    },
    {
      name: 'LiensClubsPage',
      path: '/liens/clubs',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/liens-club.html'
      },
      meta: { title: "Clubs d'ornithologie" }
    },
    {
      name: 'LiensRessourcesPage',
      path: '/liens/ressources',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/liens-ressources.html'
      },
      meta: { title: 'Ressources' }
    },
    {
      name: 'chroniquesOrnithoPage',
      path: '/chroniques-ornithologiques',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/chroniques-ornithologiques.html'
      },
      meta: { title: 'Chroniques ornithologiques' }
    },
    {
      name: 'nichoirsPage',
      path: '/nichoirs/coq',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/nichoirs.html'
      },
      meta: { title: 'Nichoirs' }
    },
    {
      name: 'photosMembresPage',
      path: '/liens-photos-membres',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/photos-membres.html'
      },
      meta: { title: 'Photos de nos membres' }
    },
    {
      name: 'DocumentsOfficielsPage',
      path: '/documents-officiels',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/documents-officiels.html'
      },
      meta: { title: 'Documents officiels' }
    },
    {
      name: 'CommanditairesPage',
      path: '/commanditaires',
      component: CommanditairesPage,
      meta: { title: 'Nos commanditaires' }
    },
    {
      name: 'DevenirMembrePage',
      path: '/adhesion',
      component: DevenirMembrePage,
      meta: { title: 'Devenir membre' }
    },
    {
      name: 'ContactPage',
      path: '/contact',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/contact.html'
      },
      meta: { title: 'Contact' }
    },
    {
      name: 'RemerciementsPage',
      path: '/remerciements',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/remerciements.html'
      },
      meta: { title: 'Remerciements' }
    },
    {
      name: 'ColibrisPage',
      path: '/colibris',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/colibris.html'
      },
      meta: { title: 'Colibris' }
    },
    {
      name: 'InscriptionPage',
      path: '/inscription',
      component: InscriptionPage,
      meta: { title: 'Inscription' }
    },
    {
      name: 'FaireDonPage',
      path: '/faire-un-don',
      component: FaireDonPage,
      meta: { title: 'Faire un don' }
    },
    {
      name: 'BoutiquePage',
      path: '/boutique',
      component: BoutiquePage,
      meta: { title: 'Boutique' }
    },
    {
      name: 'ProductPage',
      path: '/produit/:id',
      component: ProductPage,
      meta: { title: 'Produit' }
    },
    {
      name: 'LoginPage',
      path: '/connexion',
      component: LoginPage,
      meta: { title: 'Connexion' }
    },
    {
      name: 'CartPage',
      path: '/panier',
      component: CartPage,
      meta: { title: "Panier d'achats" }
    },
    {
      name: 'MembersPage',
      path: '/membre',
      component: MembersPage,
      meta: { title: 'Section membres', transition: 'fade-in-down' }
    },
    {
      name: 'ResetPasswordPage',
      path: '/mot-de-passe-oublie',
      component: ResetPasswordPage,
      meta: { title: 'Réinitialisation du mot de passe' }
    },
    {
      name: 'ConferencesPage',
      path: '/conferences',
      component: ConferencePage,
      meta: { title: 'Liste des conférences' }
    },
    {
      name: 'ActivationMembreExistant',
      path: '/activation',
      component: ActivationMembreExistant,
      meta: { title: 'Activation compte membre existant' }
    },
    {
      name: 'PolitiqueConfidentialitePage',
      path: '/politique-confidentialite',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/politique-confidentialite.html'
      },
      meta: { title: 'Politique de confidentialité' }
    },
    {
      name: 'ReglementsPolitiquesPage',
      path: '/reglements-et-politiques',
      component: PageGeneriqueHtml,
      props: {
        path: '/pages/reglements-et-politiques.html'
      },
      meta: { title: 'Règlements et politiques' }
    },
    // otherwise redirect to home
    { path: '*', redirect: '/accueil' }
  ]
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  document.title = to.meta.title;
  const restrictedPages = [ '/member' ];
  const authRequired = restrictedPages.includes(to.path);
  const loggedIn = store.getters['account/isConnected'];

  if (authRequired && !loggedIn) {
    return next('/connexion');
  }

  next();
});
